import {dashboardProfiles} from '../ui/dashboard-profiles';
import {Permissions as P} from '@myfm/domain';
import {Link} from 'react-router';
import {useWorkspaceSession} from '../ui/StaffSession';
import {PageHeader} from '../ui/PageHeader';
import {Icon,navigationIcon} from '../ui/Icon';
import {permittedWorkspaces} from '../ui/workspace-catalogue';
import {withBuildingScope} from '../ui/building-scope';
export function DashboardDirectory(){
 const session=useWorkspaceSession()!,building=session.effectiveScope.kind==='building'?session.effectiveScope.id:undefined;
 const profiles=dashboardProfiles(session);
 return <div className="dashboard-directory"><PageHeader title="Dashboards" context="Open a source-backed overview. Each source keeps its own permissions, dates and coverage limits."/>
 <h2>Working views</h2><div className="dashboard-directory__links">{profiles.map(profile=><Link key={profile.href} to={profile.href}><Icon name={navigationIcon(profile.title)}/><div><h3>{profile.title}</h3><p>{profile.note}</p></div><Icon name="chevron-right"/></Link>)}</div>
 <h2>Workspace overviews</h2><div className="dashboard-directory__links">{permittedWorkspaces(session).map(workspace=><Link key={workspace.code} to={workspace.href}><Icon name={navigationIcon(workspace.name)}/><div><h3>{workspace.name}</h3><p>{workspace.description}</p></div><Icon name="chevron-right"/></Link>)}</div>
 </div>;
}
